import { isEnrolledInCash } from 'helpers/sesameCash.helpers';
import {
  UPDATE_PERSONALINFO_REQUEST,
  UPDATE_PERSONALINFO_SUCCESS,
  UPDATE_PERSONALINFO_FAIL,
} from '../types/profileOverview.constants';
import {
  updateUserAddressPatch,
  patchUser,
} from 'externals/_services/user.service';
import { getUserInfo } from '../../../../../actions/userInfo.actions';
import { resetCreditInfo } from 'actions/creditInfo.actions';
import { getAccountMixContainer } from 'actions/dashboard.actions';
import { BUREAU_ENUMS } from 'pages/RedesignDashboard/constants';
const { TRANS_UNION } = BUREAU_ENUMS;

export const saveProfileOverview =
  (data, type, disableInfoRefresh) => (dispatch, getState) => {
    return new Promise((resolve, reject) => {
      dispatch({ type: UPDATE_PERSONALINFO_REQUEST });
      const state = getState();
      const addressValidationType = isEnrolledInCash(state?.userInfo?.userInfo)
        ? 'SMARTY_STREETS'
        : 'USER';
      const service =
        type && type === 'address'
          ? updateUserAddressPatch.bind(null, data, addressValidationType)
          : patchUser.bind(null, data);
      service()
        .then(successResponse => {
          if (!disableInfoRefresh) {
            const promises = [];
            if (!type || type !== 'address') {
              promises.push(dispatch(resetCreditInfo()));
              promises.push(
                dispatch(getAccountMixContainer({ bureau: TRANS_UNION })),
              );
            }
            promises.push(dispatch(getUserInfo()));
            return Promise.all(promises);
          }
        })
        .then(() => {
          dispatch({ type: UPDATE_PERSONALINFO_SUCCESS });
          resolve('Personal information updated');
        })
        .catch(error => {
          //do somthing on error
          dispatch({ type: UPDATE_PERSONALINFO_FAIL, error: error });
          reject(error);
        });
    });
  };
